var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRequestInfoIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 383,
    viewBox: "0 0 331 383",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.151 0C304.452 0 307.281 1.8321 316.06 7.2401C328.892 16.0281 330.918 23.4641 330.918 59.9681C330.918 82.9521 328.216 118.78 324.164 139.06C320.788 159.34 307.956 193.816 297.151 215.448C279.592 249.248 276.89 260.74 276.89 309.412C276.89 344.564 274.189 368.9 268.786 374.308C262.708 380.392 227.59 382.42 139.121 382.42C49.3 382.42 14.8575 380.392 8.10411 374.308C3.37671 369.576 0 350.648 0 331.72C0 312.792 2.70137 287.104 6.07808 274.26C9.45479 261.416 23.637 240.46 60.7808 206.66L82.3918 220.18C96.574 228.968 116.834 233.7 136.419 233.7C154.653 233.7 176.94 229.644 187.07 224.236C197.875 218.828 214.084 205.984 224.214 195.168C235.019 184.352 246.5 159.34 253.253 135.68C258.656 113.372 262.708 77.5441 262.708 56.5881C261.358 22.7881 263.384 16.7041 277.566 7.2401C286.345 1.8321 287.516 0 297.151 0Z",
    fill: "#FF3700"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.952,
    cy: 115,
    r: 91.5,
    fill: "#FF3700"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRequestInfoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/requestInfoIcon.bc8bc012.svg";
export { ForwardRef as ReactComponent };